import * as actionsTypes from "./actionTypes";

const getTerminalList = filter => ({
    type: actionsTypes.GET_TERMINAL_LIST_REQUEST,
    filter
});

const searchTerminals = searchFields => ({
    type: actionsTypes.TERMINAL_SEARCH_REQUEST,
    searchFields
});

const getTerminalData = terminalId => ({
    type: actionsTypes.GET_TERMINAL_REQUEST,
    terminalId
});

const createTerminal = terminalData => ({
    type: actionsTypes.CREATE_TERMINAL_REQUEST,
    terminalData
});

const editTerminal = (terminalId, terminalData) => ({
    type: actionsTypes.EDIT_TERMINAL_REQUEST,
    terminalId,
    terminalData
});

const deleteTerminal = terminalId => ({
    type: actionsTypes.DELETE_TERMINAL_REQUEST,
    terminalId
});

const resetTerminalForm = () => ({
    type: actionsTypes.RESET_TERMINAL_FORM
})

const getTerminalProfiles = () => ({
    type: actionsTypes.GET_TERMINAL_PROFILE_LIST_REQUEST
})

export default {
    searchTerminals,
    getTerminalData,
    createTerminal,
    editTerminal,
    deleteTerminal,
    resetTerminalForm,
    getTerminalProfiles,
    getTerminalList
}